// What's New - contenido de novedades por TANDA (whatsNewId estable).
//
// POR QUE whatsNewId Y NO LA VERSION:
//   El pipeline de Azure DevOps reescribe environment.version en cada compilación
//   (major.minor del csproj + fecha), así que anclar las novedades a la versión del build
//   hace que NUNCA coincidan. Por eso cada tanda tiene un id ESTABLE propio.
//
// COMO AGREGAR UNA TANDA NUEVA:
//   1. Copia el bloque plantilla de abajo y pégalo ARRIBA del array (más reciente primero).
//   2. Pon un whatsNewId ESTABLE y único (ej. '46570-carga-masiva'); no lo cambies después.
//   3. Llena las secciones por idioma. Deja [] las que no apliquen; la UI oculta las vacias.
//   4. show = false si quieres tenerla lista pero NO mostrarla todavia.
//
// QUE VA EN CADA SECCION (regla para todos):
//   added    (Nuevo)     -> funcionalidad/modulo que el usuario NUNCA habia visto.
//   improved (Mejorado)  -> algo que YA usaba y ahora funciona mejor/distinto.
//   fixed    (Corregido) -> arreglo de un problema de una version YA liberada al usuario.
//
// Nota: una funcionalidad nueva va completa en "added", aunque internamente mejore procesos;
// "improved"/"fixed" aplican sobre lo que el usuario ya conocia de versiones anteriores.

export interface WhatsNewSections {
    added: string[];      // Nuevo
    improved: string[];   // Mejorado
    fixed: string[];      // Corregido
}

export interface WhatsNewEntry {
    whatsNewId: string;   // id ESTABLE de la tanda (NO la version del build); dispara el modal
    show: boolean;        // false = lista pero no se muestra
    date: { es: string; en: string };
    title: { es: string; en: string };
    es: WhatsNewSections; // contenido en español
    en: WhatsNewSections; // contenido en inglés
}

export const WHATS_NEW: WhatsNewEntry[] = [

    {
        whatsNewId: '46738-sync-traspasos-tienda',
        show: true,
        date:  { es: 'Noviembre 2026', en: 'November 2026' },
        title: { es: 'Traspasos de tienda en reportes', en: 'Store transfers in reports' },
        es: {
            added: [],
            improved: [],
            fixed: [
                'Los traspasos enviados desde las tiendas ahora se reflejan correctamente en los reportes del BackOffice.'
            ]
        },
        en: {
            added: [],
            improved: [],
            fixed: [
                'Transfers sent from stores are now shown correctly in the BackOffice reports.'
            ]
        }
    },

    // ===================== Plantilla para la PROXIMA tanda (copiar y editar) ===============
    // {
    //     whatsNewId: 'feature-id-descriptivo',
    //     show: true,
    //     date:  { es: 'Mes Año', en: 'Month Year' },
    //     title: { es: 'Titulo de la tanda', en: 'Release title' },
    //     es: {
    //         added:    [ /* Nuevo: ... */ ],
    //         improved: [ /* Mejorado: ... */ ],
    //         fixed:    [ /* Corregido: ... */ ]
    //     },
    //     en: {
    //         added:    [ /* New: ... */ ],
    //         improved: [ /* Improved: ... */ ],
    //         fixed:    [ /* Fixed: ... */ ]
    //     }
    // },
    // ======================================================================================

    {
        whatsNewId: '46570-carga-masiva',
        show: true,
        date:  { es: 'Octubre 2026', en: 'October 2026' },
        title: { es: 'Carga masiva de Traspasos Corporativos', en: 'Bulk upload of Corporate Transfers' },
        es: {
            added: [
                'Carga masiva de traspasos desde Excel que se procesa en segundo plano: subes el archivo y puedes seguir trabajando; te avisamos al terminar.',
                'Ventana "Mis cargas" con el estado de cada carga y actualización automática mientras se procesan.',
                'Descarga de "no procesados" en Excel, espejo de tu layout original, con el motivo exacto por fila para corregir y resubir.',
                'Mensajes de error claros: indican la tienda y la organización exactas, el estilo/talla o la cantidad que causó el rechazo.',
                'Los códigos (sector, estilo) se conservan tal cual los subiste, sin recortes, y los contadores siempre cuadran: Procesados + No procesados = Solicitado.'
            ],
            improved: [],
            fixed: []
        },
        en: {
            added: [
                'Bulk transfer upload from Excel processed in the background: upload the file and keep working; we notify you when it finishes.',
                '"My uploads" window showing each upload status, auto-refreshing while they process.',
                'Download of "not processed" rows in Excel, mirroring your original layout, with the exact reason per row to fix and re-upload.',
                'Clear error messages: they state the exact store and organization, style/size or quantity that caused the rejection.',
                'Codes (sector, style) are kept exactly as uploaded, without truncation, and counters always add up: Processed + Not processed = Requested.'
            ],
            improved: [],
            fixed: []
        }
    }
];

/** Devuelve la entrada de novedades de una tanda si existe y está marcada para mostrarse. */
export function getWhatsNewFor(whatsNewId: string): WhatsNewEntry | null {
    const entry = WHATS_NEW.find(e => e.whatsNewId === whatsNewId);
    return entry && entry.show ? entry : null;
}

/**
 * Tanda ACTUAL a mostrar: la primera del array (más reciente) marcada con show = true.
 * El layout usa esto para no depender de environment.version (que el pipeline reescribe).
 */
export function getCurrentWhatsNew(): WhatsNewEntry | null {
    return WHATS_NEW.find(e => e.show) ?? null;
}
